import { API } from 'aws-amplify';

export const getStats = async () => {
  const statsData = await API.get('delta-api', 'online-attendance/stats', {});
  return statsData || [];
};
